export default "__VITE_ASSET__8339e4fe__"